import { useState, useEffect } from 'react';
import { getListModuleContentLibrary, getListModuleSupportContentLibrary, getListCourseContentLibrary, addCollectionLibrary, deleteCollectionLibrary } from '../../../../../../../../../api/repositories';

const useActions = (loadingLP, journeyId, courseId, setListModule, setListModuleSupport, setLoadingLM, mainState, reFetchLeftSection, setRefetchLeftSection, setPercentCompleteCourse) => {

    const [ loading, setLoading] = useState(true);
    const [ currCourse, setCourse ] = useState([])
    const [ loadingAdd, setLoadingAdd ] = useState(true)
    const [ statusAdd, setStatusAdd ] = useState()
    const [ loadingDelete, setLoadingDelete ] = useState(true)
    const [ statusDelete, setStatusDelete ] = useState()

    const url = window.location.pathname;
    const arrId = url.split('/');
    const courseIdPosition = arrId.indexOf('course')
    const currentCourseId = parseInt(arrId[courseIdPosition + 1])

    const fetchDetailCourse = async() => {
        setLoading(true);
        setLoadingLM(true)

        try {
            const { data } = await getListModuleContentLibrary(parseInt(arrId[3]), journeyId, currentCourseId);
            setCourse(data)
            setListModule(data)
            mainState.setLastModule(data)

            // for Header title purpose set title journey
            mainState.setAcademyNameHeader("PROGRAM_"+data.journey.name)
        } catch (err) {
            setCourse(null)
            setListModule(null)
            setLoadingLM(false)
        } finally {
            fetchSupportingModule()
        }
    };

    const fetchSupportingModule = async() => {

        try {
            const { data } = await getListModuleSupportContentLibrary(parseInt(arrId[3]), journeyId, currentCourseId);
            setListModuleSupport(data)
            mainState.setLastModuleSupport(data)
        } catch (err) {
            setListModuleSupport(null)
            setLoadingLM(false)
        } finally {
            setLoading(false);
            setLoadingLM(false)
            mainState.setDefaultKeyListCourse(null)
        }
    }

    // only to get percentage Course completed and Modules Completed
    const reFetchDetailJourney = async() => {

        const url = window.location.pathname;
        const arrId = url.split('/');
        const journeyIdPosition = arrId.indexOf('journey')
        const currentId = parseInt(arrId[journeyIdPosition + 1])

        try {
            const { data } = await getListCourseContentLibrary(parseInt(arrId[3]), currentId);
            countPercentageCourses(data.courses);
            countEssentialCompleted(data.courses);
        } catch (err) {
            
        } finally {
            if(reFetchLeftSection === true) setRefetchLeftSection(false);
        }
    };

    const countPercentageCourses = (data) => {
        let completeCourse = 0;
        data.map((v) => {
            if(v.is_completed == 1) {
                completeCourse++;
            }
        });
        const percent = data.length > 0 ? Math.round((completeCourse/data.length) * 100) : 0;
        setPercentCompleteCourse(percent);
    }

    const countEssentialCompleted = (data) => {
        document.querySelectorAll('.amount-module-completed').forEach((e, idx) => {
            e.innerHTML = data[idx].total_completed;
        })
    }

    const addCourseToCollection = async(id, type) => {
        setLoadingAdd(true)
        const payloadAddCollection = {
            ref_id : id,
            type : type,
            content_library_id : parseInt(arrId[3]) // id Content Library Academy
        }

        try {
            const { status, message, description, data } = await addCollectionLibrary({data: payloadAddCollection});
            setStatusAdd(status)
        } catch (err) {
            console.log("Error Add Collection "+err)
            setLoadingAdd(false)
            setStatusAdd(-1)
        } finally {
            setLoadingAdd(false)   
        }
    }

    const deleteCollection = async(id, type) => {
        setLoadingDelete(true)
        const payloadDelete = {
            ref_id : id,
            type : type
        }

        try {
            const { status, message, description, data } = await deleteCollectionLibrary({data: payloadDelete});

            setStatusDelete(status);
        } catch (err) {
            console.log("Error Delete Collection "+err)
            setLoadingDelete(false)
            setStatusDelete(-1)
        } finally {
            setLoadingDelete(false)
        }
    }


    useEffect(() => {
        if(loadingLP === false && mainState.defaultKeyListCourse !== null) fetchDetailCourse();
    }, [loadingLP, courseId]);

    useEffect(() => {
        if(mainState.reFetchJourney === true) reFetchDetailJourney()
    },[mainState])

    return {
        currCourse,
        addCourseToCollection,
        loadingAdd,
        setLoadingAdd,
        statusAdd,
        deleteCollection,
        loadingDelete,
        setLoadingDelete,
        statusDelete
    };
};

export default useActions;